import React, { useState, useRef } from "react";
import { updateMemberDetails } from "../../api/member";
import Webcam from "react-webcam";
import { CameraOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const UpdateMember = ({ location }) => {
  const { user } = useSelector((state) => ({ ...state }));
  const webRef = useRef();
  const member = location.state;
  const initialState = {
    fname: member.fname,
    lname: member.lname,
    email: member.email,
    phone: member.phone,
    gender: member.gender,
    address: {
      first_line: member.address.first_line,
      second_line: member.address.first_line,
      city: member.address.city,
    },
    expire: member.expire,
    profile: member.profile,
  };
  console.log(member);
  const [values, setValues] = useState(initialState);
  const [capturing, setCapturing] = useState(false);

  const handleChange = (e) => {
    e.preventDefault();
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleAddressChange = (e) => {
    let { address } = values;
    setValues({
      ...values,
      address: { ...address, [e.target.name]: e.target.value },
    });
  };
  const handleCapture = (e) => {
    e.preventDefault();
    values.profile = webRef.current.getScreenshot();
    setCapturing(false);
  };

  const handleCloseCamera = (e) => {
    e.preventDefault();
    setCapturing(false);
  };
  const setGender = (e) => {
    setValues({ ...values, gender: e.target.value });
  };

  const handleSubmit = async () => {
    await updateMemberDetails(user.token, member._id, values)
      .then((res) => {
        console.log(res);
        toast.success("Updated Successfully");
      })
      .catch((err) => {
        console.log(err);
        alert("error occured");
      });
  };

  return (
    <div className="container my-5">
      <div className="row">
        <div className="col-md-12">
          <div className="heading">
            <h2>Update Member Details</h2>
          </div>
          <div className="form">
            <div className="row">
              <div className="col-md-6">
                <label htmlFor="fname" className="form-label">
                  First Name*
                </label>
                <input
                  type="text"
                  name="fname"
                  value={values.fname}
                  placeholder="Vikram"
                  className="form-control mb-3"
                  id="fname"
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="lname" className="form-label">
                  Last Name*
                </label>
                <input
                  type="text"
                  name="lname"
                  value={values.lname}
                  placeholder="Singh"
                  className="form-control mb-3"
                  id="lname"
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <label className="form-check-label">Gender</label>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="gender"
                    value="male"
                    id="male"
                    onChange={setGender}
                    checked={values.gender}
                    required={true}
                  />
                  <label className="form-check-label" htmlFor="male">
                    Male
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    value="female"
                    name="gender"
                    id="female"
                    onChange={setGender}
                    checked={values.gender === "female"}
                    required={true}
                  />
                  <label className="form-check-label" htmlFor="female">
                    Female
                  </label>
                </div>
              </div>
              <div className="col-md-4">
                <label htmlFor="phone" className="form-label">
                  Phone*
                </label>
                <input
                  type="number"
                  name="phone"
                  placeholder="99999993467"
                  value={values.phone}
                  className="form-control mb-3"
                  id="phone"
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="email" className="form-label">
                  Email address*
                </label>
                <input
                  type="email"
                  name="email"
                  value={values.email}
                  className="form-control mb-3"
                  placeholder="info@gmail.com"
                  id="email"
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div
              style={{ marginBottom: "30px" }}
              className="row justify-content-center"
            >
              <div className="col-md-6">
                <label className="form-date-label" htmlFor="DOB-member">
                  Date Of Birth*
                </label>
                <input
                  type="date"
                  name="DOB"
                  value={values.DOB}
                  className="form-control mb-3"
                  id="DOB-member"
                  onChange={handleChange}
                  required
                />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
                className="col-md-6"
              >
                <div
                  style={{ width: "100px", height: "80px" }}
                  className="web-cam-div me-4"
                >
                  {capturing && (
                    <div style={{ position: "relative" }}>
                      <Webcam
                        ref={webRef}
                        width={100}
                        height={80}
                        screenshotQuality={1}
                        imageSmoothing={false}
                      />
                    </div>
                  )}
                  {values.profile && values.profile.trim() && !capturing && (
                    <img src={values.profile} alt="profile" />
                  )}
                </div>
                <div
                  style={{ cursor: "pointer" }}
                  className="capture-member-image"
                >
                  <CameraOutlined
                    onClick={(e) => setCapturing(true)}
                    style={{ fontSize: "40px" }}
                  />
                  <h6>Capture</h6>
                  {capturing && (
                    <div style={{ position: "relative" }}>
                      <button onClick={handleCloseCamera}>X</button>
                      <button onClick={handleCapture}>C</button>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <label htmlFor="first_line" className="form-label">
                  Address*
                </label>
                <input
                  type="text"
                  value={values.address.first_line}
                  name="first_line"
                  placeholder="House No. 4, Block No. 4"
                  className="form-control mb-3"
                  id="first_line"
                  onChange={handleAddressChange}
                  required
                />
              </div>
              <div className="col-md-12">
                <label htmlFor="second_line" className="form-label">
                  Address 2
                </label>
                <input
                  type="text"
                  value={values.address.second_line}
                  name="second_line"
                  placeholder="Indraprastha Colony"
                  className="form-control mb-3"
                  id="second_line"
                  onChange={handleAddressChange}
                />
              </div>
              <div className="col-md-12">
                <label htmlFor="city" className="form-label">
                  City*
                </label>
                <input
                  type="text"
                  value={values.address.city}
                  name="city"
                  placeholder="delhi"
                  className="form-control mb-3"
                  id="city"
                  onChange={handleAddressChange}
                />
              </div>
            </div>
            <button
              className="btn btn-info my-4 text-white"
              onClick={handleSubmit}
            >
              Submit Details
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateMember;
